import React, {useState} from 'react';

import {BioentitySummary} from 'folder-items/FileConstants';
import {BioentitySearchInputProps} from 'inventory/BioentitySearchInput';
import BaseEditableField from 'ui-library/BaseEditableField';
import {BioentityChip} from 'ui-library/chips/BioentityChip';
import {ChipSize} from 'ui-library/chips/Chip';

import EquipmentSearchInput from './EquipmentSearchInput';

interface EquipmentEditableFieldProps {
  initialSelection: Array<BioentitySummary>;
  onComplete: (selectedEquipment: Array<BioentitySummary>) => void;
  isWriteable: boolean;
  shouldAllowMultiple?: boolean;
  editorOnly?: boolean;
  adapterId?: string | null;
}

export function EquipmentEditableField(props: EquipmentEditableFieldProps): JSX.Element {
  const [selectedEquipment, setSelectedEquipment] = useState(props.initialSelection ?? []);
  const [isBeingEdited, setIsBeingEdited] = useState(props.editorOnly ?? false);

  return (
    <BaseEditableField
      editor={
        <EquipmentSearchInput
          onChange={(equipment) => {
            setSelectedEquipment(equipment as Array<BioentitySummary>);
          }}
          selectedItems={selectedEquipment}
          shouldAllowMultiple={props.shouldAllowMultiple}
          adapterId={props.adapterId}
        />
      }
      isBeingEdited={isBeingEdited}
      isCompleteEnabled={true}
      isWritable={props.isWriteable}
      viewer={
        <div>
          {selectedEquipment.map((item, index) => (
            <BioentityChip
              className="u-mini-spacing-top"
              id={item.id}
              isLink={true}
              isInaccessible={!item.id}
              key={index}
              size={ChipSize.MINI}
              validationExtras={null}
            />
          ))}
        </div>
      }
      onCancel={function (): void {
        setIsBeingEdited(false);
        setSelectedEquipment(props.initialSelection);
      }}
      onComplete={function (): void {
        setIsBeingEdited(false);
        props.onComplete(selectedEquipment);
      }}
      onEdit={function (): void {
        setIsBeingEdited(true);
      }}
    />
  );
}

export type EquipmentSearchInputProps = Omit<
  BioentitySearchInputProps,
  'bioentityTypes' | 'placeholderText' | 'tagSchemaOrInterfaceId'
>;
